import http from '@/services/httpClient';

export const getDetails = async (cod, id) => {
  const result = http.get(`/psychologists/${cod}/appointments/${id}/`, {
    headers: {
      Authorization: `Token ${localStorage.getItem('user-token')}`,
    },
  });
  return result;
};

export const getConsultationsNow = async (cod, date) => {
  const result = await http.get(`/psychologists/${cod}/appointments/`, {
    params: {
      date,
    },
    headers: {
      Authorization: `Token ${localStorage.getItem('user-token')}`,
    },
  });
  return result;
};

export const signUp = async (user, specialities) => {
  const { data, status } = await http.post('/psychologists/', user);
  if (status == 200) {
    const result = await http.post(`/psychologists/${data.id}/specialities/`, {
      id: specialities,
    },
    {
      headers: { Authorization: `Token ${data.token}` },
    });
    return result;
  }
};

export const createSchedule = async (cod, list) => {
  const token = await localStorage.getItem('user-token');
  const result = await http.post(`/psychologists/${cod}/time_slots/`, {
    list,
  },
  {
    headers: { Authorization: `Token ${token}` },
  });

  return result;
};

export const deleteSchedule = async (cod, date) => {
  const result = await http.delete(`/psychologists/${cod}/time_slots/`, {
    headers: {
      Authorization: `Token ${localStorage.getItem('user-token')}`,
    },
    params: {
      date,
    },
  });
  return result;
};

export const getSchedule = async (cod, date) => {
  const result = await http.get(`/psychologists/${cod}/time_slots/`, {
    params: {
      date,
    },
    headers: {
      Authorization: `Token ${localStorage.getItem('user-token')}`,
    },
  });
  return result;
};
